<app-page>
  <app-import-queue-entry
    *ngIf="entryId"
    [entryId]="entryId"
  ></app-import-queue-entry>
</app-page>
